<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Anggota Baru</h5>
      </template>

      <b-row class="mb-3">
        <b-col cols="12" md="6" v-if="optionsCabang.length > 2">
          <b-form-group label="Cabang">
            <multiselect name="dariCabang" v-model="filters.cabang" :options="optionsCabang" :internal-search="true"
              :allow-empty="false" deselect-label="" select-label="" label="name" track-by="name" placeholder="Semua" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="No. Anggota">
            <b-form-input v-model="filters.noAnggota" id="filterInput" type="search" placeholder="Masukkan No. Anggota"
              @keyup.enter="onSearch()" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="Status">
            <b-form-select v-model="filters.status" id="filterStatus" name="status" :options="optionsStatus" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" lg="6">
          <b-form-group label="Tanggal Dibuat">
            <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
              <b-form-input v-model="filters.startDate" name="filterFromDate" id="filterDate" type="date"
                class="flex-fill"></b-form-input>
              <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
              <b-form-input v-model="filters.endDate" name="filterToDate" type="date" class="flex-fill"></b-form-input>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <div class="d-flex flex-wrap justify-content-between gap-2">
            <div class="d-flex flex-wrap gap-2">
              <b-button variant="pgiBtn" :disabled="isBusy" class="mr-2" @click="onSearch()">
                Search
              </b-button>
              <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
            </div>
            <div>
              <b-button variant="success" :disabled="isBusy || isLoadingTrackProgress" class="mr-2"
                @click="onShowModalTrackProgress()">
                <i class="fa fa-line-chart mr-1"></i>
                Track Progress
              </b-button>
              <b-button variant="pgiBtn" :disabled="isBusy" @click="onShowModalMulaiKerja()">
                Mulai Kerja
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="detail-data-wrapper">
        <b-table bordered hover show-empty :busy="isBusy" :items="data" :no-local-sorting="false" :fields="fields"
          responsive class="mb-3">
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading data...</strong>
            </div>
          </template>
          <template v-slot:empty>
            Tidak ada data.
          </template>
          <template #cell(data_anggota)="row">
            <div class="smallText">
              <span class="text-muted">Cabang:</span> {{ row.item.nasabahCabang }}
            </div>
            <div class="smallText">
              <span class="text-muted">No. Anggota:</span> {{ row.item.nasabahNo }}
            </div>
            <div class="smallText">
              <span class="text-muted">Nama:</span> {{ row.item.nasabahNama }}
            </div>
          </template>
          <template #cell(info_log)="row">
            <div class="smallText">
              <span class="text-muted">Dibuat pada:</span> {{ row.item.createdAt ?
                $helper.changeDateFormat(row.item.createdAt) : '' }} - {{ row.item.createdAt ?
                $helper.changeDateFormatGetHour(row.item.createdAt) : '' }}
            </div>
            <div class="smallText">
              <span class="text-muted">Dibuat oleh:</span> {{ row.item.createdBy || '-' }}
            </div>
            <div class="smallText">
              <span class="text-muted">Diverifikasi pada: </span> {{ row.item.verifiedAt ?
                $helper.changeDateFormat(row.item.verifiedAt) : '' }} - {{ row.item.verifiedAt ?
                $helper.changeDateFormatGetHour(row.item.verifiedAt)
                : '' }}
            </div>
            <div class="smallText">
              <span class="text-muted">Diverifikasi oleh: </span> {{ row.item.verifiedBy || '-' }}
            </div>
          </template>
          <template #cell(notes)="row">
            <div class="smallText">
              {{ row.item.verifiedNote }}
            </div>
          </template>
          <template #cell(status)="row">
            <span :class="getStatus(row.item.status).class">
              {{ getStatus(row.item.status).text }}
            </span>
          </template>
          <template #cell(actions)="row">
            <b-link :to="`${$route.path}/${row.item.nasabahId}`">
                <b-button size="sm" variant="pgiBtn" v-b-tooltip.hover title="Detail">
                    <i class="fa fa-info"></i>
                </b-button>
            </b-link>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ totalViewText }}</span>
          </b-input-group>
          <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            aria-controls="my-table" @input="onPageChange"></b-pagination>
        </div>
      </div>
    </b-card>

    <ModalConfirm id="modal-confirm-start-work" title="Konfirmasi Mulai Kerja"
      :isSubmitting="isLoadingStartWork" desc="Apakah Anda yakin ingin memulai kerja?"
      @submit="handleStartWork" />

    <b-modal id="modal-track-progress" size="lg" title="Track Progress Anggota Baru" no-close-on-backdrop>
      <b-alert show variant="info">
        <i class="fa fa-info-circle mr-2"></i>
        Menampilkan rekap progress 3 hari terakhir (termasuk hari ini).
      </b-alert>
      <b-table bordered responsive show-empty :busy="isLoadingTrackProgress" :items="trackProgressItems"
        :fields="trackProgressFields" class="mb-0">
        <template v-slot:table-busy>
          <div class="text-center text-muted my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading data...</strong>
          </div>
        </template>
        <template v-slot:empty>
          Tidak ada data.
        </template>
      </b-table>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Tutup</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  data() {
    return {
      initStatus: 0,
      isBusy: false,
      optionsCabang: [],
      data: [],
      fields: [
        { key: 'data_anggota', label: 'Data Anggota'},
        { key: 'info_log', label: 'Waktu & Petugas' },
        { key: 'notes', label: 'Keterangan', thClass: 'max-width-150', tdClass: 'max-width-150' },
        { key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'Aksi', thClass: 'text-center', tdClass: 'text-center' }
      ],
      optionsStatus: [
        {
          text: 'Semua',
          value: '',
        },
        {
          text: 'Pending',
          value: CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.PENDING,
        },
        {
          text: 'Yakin Benar',
          value: CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.VERIFIED,
        },
        {
          text: 'Yakin Salah',
          value: CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.REJECTED,
        },
      ],
      filters: {
        cabang: null,
        noAnggota: '',
        status: CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.PENDING,
        startDate: null,
        endDate: null,
      },
      currentPage: 1,
      show: 10,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      totalViewText: "",
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      isMobile: false,
      isLoadingStartWork: false,
      isLoadingTrackProgress: false,
      trackProgressFields: [
        { key: 'tanggal', label: 'Tanggal' },
        { key: 'nama', label: 'Nama' },
        { key: 'yakinBenar', label: 'Yakin Benar', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'yakinSalah', label: 'Yakin Salah', thClass: 'text-center', tdClass: 'text-right' },
      ],
      trackProgressItems: [],
    }
  },
  methods: {
    async init() {
      this.initStatus = 0
      try {
        this.getCabang()
        await this.getItems()
        this.initStatus = 1
      } catch (error) {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      }
    },
    async getItems(page = 1) {
      this.isBusy = true;
      this.data = [];
      this.currentPage = isNaN(page) ? 1 : page;

      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
      }

      if (this.optionsCabang.length <= 2) {
        this.filters.cabang = this.optionsCabang[1]
      }

      if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
        params.cabangId = this.filters.cabang.id;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.noAnggota)) {
        params.noAnggota = this.filters.noAnggota
      }

      if (!this.$helper.isNullOrEmpty(this.filters.status) || this.filters.status == CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.PENDING) {
        params.status = this.filters.status;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
        params.startDate = this.filters.startDate;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
        params.endDate = this.filters.endDate;
      }

      return this.$axios.get("nasabah/verifikasi-get-data", {
        params,
      }).then(res => {

        this.data = res.data.content
        this.totalRows = res.data.totalElements

        let pg = this.currentPage - 1

        let prev = pg * this.show + 1
        let limit = pg * this.show + this.show
        if (limit > this.totalRows) limit = this.totalRows

        this.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRows + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        throw error
      })
        .finally(() => {
          this.isBusy = false
        })
    },
    getCabang() {
      const getCabang = localStorage.getItem("cabang")
      const cabang = JSON.parse(getCabang);

      const mappingName = cabang.map(item => ({
        ...item,
        name: item.name.replace(/^\(\d+\)\s*/, "")
      }));

      this.optionsCabang = [
        { id: null, name: "Semua Cabang" },
        ...mappingName
      ]
    },
    onSearch() {
      this.getItems()
    },
    onReset() {
      this.filters = {
        cabang: null,
        noAnggota: '',
        status: CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.PENDING,
        startDate: null,
        endDate: null,
      }

      this.getItems()
    },
    getStatus(status) {
      if (status === CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.PENDING) return { text: 'Pending', class: 'status-box-md status-box-warning' };
      if (status === CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.VERIFIED) return { text: 'Yakin Benar', class: 'status-box-md status-box-success' }
      if (status === CONSTANTS.ANGGOTA.STATUS_VERIFIKASI_ANGGOTA.REJECTED) return { text: 'Yakin Salah', class: 'status-box-md status-box-danger' }

      return { text: '-', class: 'status-box-md status-box-default' }
    },
    onLimitChange(newPerPage) {
      this.perPage = newPerPage
      this.getItems()
    },
    onPageChange(newPage) {
      this.getItems(newPage)
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 576;
    },
    onShowModalTrackProgress() {
      this.$bvModal.show('modal-track-progress')
      this.getTrackProgress()
    },
    getTrackProgress() {
      this.isLoadingTrackProgress = true
      this.trackProgressItems = []

      this.$axios.get('nasabah/verifikasi-get-report').then(response => {
        this.trackProgressItems = response.data || []
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingTrackProgress = false
      })
    },
    onShowModalMulaiKerja() {
      this.$bvModal.show('modal-confirm-start-work')
    },
    handleStartWork() {
      this.isLoadingStartWork = true;
      this.$axios.post('nasabah/find-for-verify').then(response => {
        const id = response.data.id;
        if (id) {
          this.$router.push(`/persetujuan/anggota-baru/${response.data.id}`)
        } else {
          this.showNotifDoneWork()
          this.$bvModal.hide('modal-confirm-start-work')
        }
      }).catch(error => {
        this.$helper.parseError(this, error)
      }).finally(() => {
        this.isLoadingStartWork = false;
      })
    },
    showNotifDoneWork() {
      this.$bvToast.toast(
        'Saat ini tidak ada pekerjaan yang menunggu persetujuan.',
        {
          title: 'Informasi',
          solid: true,
          variant: 'info'
        }
      )
    }
  },
  created() {
    this.init();
  },
  mounted() {
    const doneWork = this.$route.query.doneWork === 'true'

    if (doneWork) {
      this.showNotifDoneWork()
    }
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
}
</script>
